import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Text, { TEXT_SIZE, TEXT_COLOR } from "@gc-npm/components.text";
import IconGlyph from "@gc-npm/components.icon-glyph";
import CustomLink from "@gc-npm/components.custom-link";
import { COLORS } from "@gc-npm/utils.enums.colors";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { SCREEN_TYPES } from '@/utils/constants';
import ChangeFusionToMiMovistarModal from "@/components/Modals/ChangeFusionToMiMovistarModal";

const CallOut = ({ icon, title, text, textLink, width, idModal, modalProps = {} }) => {

  const dispatch = useDispatch();
  const screenType = useSelector((state) => state.UI.screenType);
  const isMobile = screenType === SCREEN_TYPES.MOBILE;
  const showModal = () => {
    dispatch(
      modalActions.addModal({
        id: idModal ,
        Element2Show: ChangeFusionToMiMovistarModal,
        modalProps: {
        closeByClickingOutside: true,
          contentPosition: 'center--center',
          inSceneEffect: isMobile ? 'fadeInBottom' : 'fadeIn',
          outSceneEffect: isMobile ? 'fadeOutBottom' : 'fadeOut',
          opacityLayoutColor: 'blur',
          scrollAllowed: false,
        },
        elementProps: {
          screenType,
          ...modalProps,
        },
      })
    );
  };

  return (
    <div className="collout" role="note" aria-live="polite">
      {icon?.id && (
        <div className="collout__icon" aria-hidden="true">
          <IconGlyph
            height={20}
            color={icon?.color || TEXT_COLOR.MOVISTAR_BLUE}
            kind={icon?.kind || "m"}
            {...icon}
          />
        </div>
      )}
      <div className="collout__content">
        {title?.text && (
          <div className="collout__title">
            <Text size={TEXT_SIZE.SUBTITLE1} color={TEXT_COLOR.MOVISTAR_BLACK} {...title} />
          </div>
        )}

        {text?.text && (
          <div className="collout__text">
            <Text size={TEXT_SIZE.BODY2} color={TEXT_COLOR.GREY_600} {...text} />
          </div>
        )}

        {textLink?.text && (
          <div className="collout__link">
            <CustomLink className="collout__custom-link" onClick={showModal}>
              <Text size={TEXT_SIZE.BODY2} color={TEXT_COLOR.BLUE_A} {...textLink} />
            </CustomLink>
          </div>
        )}
      </div>

      <style jsx>{`
        .collout {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 14px 16px;
          border-radius: 10px;
          background-color: ${COLORS.grey100};
          width: ${width};
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .collout {
            width: 100%;
          }
        }

        .collout__icon {
          flex: 0 0 auto;
          margin-top: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 0;
        }

        .collout__content {
          flex: 1 1 auto;
          min-width: 0;
        }

        .collout__title {
          margin-bottom: 2px;
        }

        .collout__text {
          margin-top: 2px;
        }

        .collout__link {
          margin-top: 20px;
        }

        .collout__custom-link :global(a),
        .collout__custom-link :global(button) {
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          padding: 0;
          background: transparent;
          border: 0;
        }

        .collout__custom-link :global(a:hover),
        .collout__custom-link :global(button:hover) {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
};

CallOut.defaultProps = {
  icon: null,
  title: null,
  text: null,
  textLink: null,
  width: "100%",
};

export default CallOut;